import React from 'react';
import styles from './more.module.scss';
import { KoTabs } from 'packages';
import Component from '../component';
import Module from '../module';
import Epic from '../epic';
import Services from '../service';
export default function MoreComponents() {
  return (
    <div className={`${styles.wrapper} profileSection`}>
      <KoTabs options={[{ label: 'Components', key: 'components', children: <Component /> },
        { label: 'Modules', key: 'modules', children: <Module /> },
        { label: 'Epic', key: 'epic', children: <Epic /> },
        { label: 'Services', key: 'services', children: <Services /> }
      ]} />,
    </div>
  );
}
